import { Container } from '@pixi/react'
import { VoucherSelectPopup } from './selectPopup/VoucherSelectPopup'
import { memo } from 'react'
import { VoucherHeader } from './header/VoucherHeader'
import { VoucherTotalWinPopup } from './totalWinPopup/VoucherTotalWinPopup'

export const Voucher = memo(() => {
  return (
    <Container name="Voucher">
      <VoucherHeader />
      <VoucherSelectPopup />
      <VoucherTotalWinPopup />
    </Container>
  )
})
